import { Header } from "@/components/Header";
import { AboutDossier } from "@/components/about/AboutDossier";
import { AboutEditorial } from "@/components/about/AboutEditorial";

import { Footer } from "@/components/Footer";
import { SEOWrapper } from "@/components/SEOWrapper";
import { getSEOTemplate } from "@/data/seoTemplates";
import { usePageSeo } from "@/hooks/usePageSeo";
// Retrato real de Luis ROC ya presente en el proyecto
const luisRocHeroImage = "/media/luis-roc/portrait.png";

const AboutPage = () => {
  const { language, url, esUrl, enUrl, onLanguageChange } = usePageSeo();

  const seoTemplate = getSEOTemplate('about');
  
  if (!seoTemplate) {
    return <div>SEO Template not found</div>;
  }

  return (
    <SEOWrapper
      title={seoTemplate.title[language]}
      description={seoTemplate.description[language]}
      keywords={seoTemplate.keywords[language]}
      url={url}
      esUrl={esUrl}
      enUrl={enUrl}
      language={language}
      ogImage={luisRocHeroImage}
      pageType="website"
      structuredData={{
        type: 'organization',
        data: {
          name: "Luis ROC",
          jobTitle: language === 'es' ? "Consultor SEO y Marketing Digital" : "SEO and Digital Marketing Consultant",
          description: seoTemplate.description[language],
          url: seoTemplate.url[language],
          image: luisRocHeroImage,
          expertiseFocus: "SEO, Search Growth, Google Ads, Amazon",
          expertise: ["SEO", "Google Ads", "Digital Marketing", "LLM Positioning", "Amazon Consulting"],
          areaServed: "Houston, Texas",
          targetAudience: language === 'es' ? "Empresas hispanas" : "Hispanic businesses",
          languages: ["Spanish", "English"],
          company: {
            name: "ROC Worldwide Agency LLC",
            url: "https://luisroc.com"
          }
        }
      }}
      summary={language === 'es' 
        ? "Luis ROC, consultor en SEO y Search Growth, especializado en ayudar a empresas hispanas a crecer en el mercado digital estadounidense. CEO de ROC Worldwide Agency."
        : "Luis ROC, SEO and Search Growth consultant, specialized in helping Hispanic businesses grow in the US digital market. CEO of ROC Worldwide Agency."
      }
      keyPoints={language === 'es' ? [
        "Experiencia en SEO, Search Growth y marketing digital",
        "CEO y fundador de ROC Worldwide Agency LLC",
        "Especializado en mercado hispano estadounidense",
        "Experto en SEO, SEM y posicionamiento LLM",
        "Servicios bilingües (español e inglés)",
        "Enfoque en ROI y resultados medibles"
      ] : [
        "Experience in SEO, Search Growth and digital marketing",
        "CEO and founder of ROC Worldwide Agency LLC",
        "Specialized in US Hispanic market",
        "Expert in SEO, SEM and LLM positioning",
        "Bilingual services (Spanish and English)",
        "Focus on ROI and measurable results"
      ]}
    >

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={onLanguageChange} />
        
        <main>
          <AboutDossier language={language} />
          <AboutEditorial language={language} />
        </main>

        
        <Footer language={language} />
      </div>
    </SEOWrapper>
  );
};

export default AboutPage;
